import Coupon from '@components/membership/coupon/Coupon'
import { LiteMemberAvatar } from '@components/membership/LiteMemberAvatar'
import { LitePlanTag } from '@components/membership/LitePlanTag'
import { Coupon as CouponModel } from '@models/membership/Coupon'
import { Typography } from 'antd'
import dayjs from 'dayjs'
import { ComponentProps } from 'react'

const { Text } = Typography

/**
 * The lite embeds the analytics read-model rows carry (ticket 537, API #298),
 * taken from the renderers themselves so the two row models stay the single
 * source of truth for their own fields.
 */
type LiteMember = ComponentProps<typeof LiteMemberAvatar>['member']
type LitePlan = ComponentProps<typeof LitePlanTag>['plan']

/*
 * Cells the transaction table and the incoming-renewal table render
 * identically, so the two cannot drift apart. Only the column widths differ
 * between them, so those stay declared on each side. The Net amount cell is
 * deliberately NOT shared: a transaction always has an amount, an incoming
 * renewal's next payment can be unknown and falls back to `--`.
 */

/** Date as "Jul 03, 2026", never wrapped; `--` when the row carries none. */
const renderDateCell = (date: string | null) => (
  <Text style={{ whiteSpace: 'nowrap' }}>
    {date ? dayjs(date).format('MMM DD, YYYY') : '--'}
  </Text>
)

const renderMemberCell = (member: LiteMember) => (
  <LiteMemberAvatar member={member} />
)

const renderPlanCell = (plan: LitePlan) => <LitePlanTag plan={plan} />

const renderCouponCell = (coupon: CouponModel | null) =>
  coupon ? (
    // The coupon code on the tag (Figma v2.1), as the other membership lists
    // that name a coupon do.
    <Coupon.Avatar model={coupon} />
  ) : (
    <Text type="secondary">--</Text>
  )

export { renderCouponCell, renderDateCell, renderMemberCell, renderPlanCell }
